<template>
  <div class="shadow rounded-1">
    <h2 class="text-center pt-3">Status Penyampaian Laporan Tahunan ({{ filterTahun }})</h2>
    <apexchart type="pie" height="398" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: ['jumlah_laporan_status_penyampaian', 'filterTahun'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      series: [0, 0],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: ['Terlambat', 'Tepat Waktu'],
        colors: ['#FF4D4D', '#00e396'],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex]
          },
        },
        legend: {
          position: 'bottom',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
    }
  },
  watch: {
    jumlah_laporan_status_penyampaian: {
      handler(val) {
        if (!val) return
        this.series = val.series
      },
    },
  },
}
</script>
